import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";

export default function NodeCanBeLink(node:LayoutNode):boolean{

    let parent = node.parent;
    while(parent){
 
      if(parent.componentAttributes["isLink"]==="true"){
          
        return false;
      }
      parent = parent.parent;
    }


    return true;


}